import React from 'react';
import {
  Box, ChevronDownIcon,
  ChevronUpIcon, Heading, RawButton, } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  title: string;
  isExpanded: boolean;
  setIsExpanded: (val: boolean) => void;
}

const ModuleTitle: React.FC<Props> = ({ testId, title, isExpanded, setIsExpanded }) => (
  <RawButton
    data-testid={`${testId}_title`}
    onClick={() => setIsExpanded(!isExpanded)}
  >
    <Box direction="row" align="center">
      <Box margin={{ right: 'spacing16' }}>
        { isExpanded ? (
          <ChevronUpIcon color="textTitle" />
        ) : (
          <ChevronDownIcon color="textTitle" />
        )}
      </Box>
      <Heading
        fill
        level={4}
        size="21px"
        color="textTitle"
      >
        {title}
      </Heading>
    </Box>
  </RawButton>
);

export default ModuleTitle;
